import React, { useState } from 'react';
import { Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';

const NavbarComponent = () => {
    const [showCoursesDropdown, setShowCoursesDropdown] = useState(false);
    const location = useLocation(); // Get current route

    return (
        <div className="catering-section">
            <div className='navlist-chef'>
               <div className="contact-media d-flex justify-content-between align-items-center pt-3 pb-2 text-light d-none d-lg-flex">
  {/* Contact Info - Center */}
  <div className="flex-grow-1 d-flex justify-content-center">
    <div className="contact-info d-flex gap-3">
      <p><i className="fa-solid fa-envelope" style={{ color: "#ffffff" }}></i> info@finesseacademyarts.com</p>
      <p><i className="fa fa-phone" style={{ color: "#ffffff" }}></i>&nbsp;+91 9445744663</p>
      <p><i className="fa fa-clock" style={{ color: "#ffffff" }}></i> &nbsp;Mon-Sat: 9.00 am-5.00 pm</p>
    </div>
  </div>

  {/* Social Media - End */}
  <div className="social-media d-flex gap-3 pe-4">
    <a href="https://www.facebook.com/finesseacademyarts" target="_blank" rel="noreferrer">
      <i className="fa-brands fa-facebook-f" style={{ color: "#d5a092" }}></i>
    </a>
    <a href="https://www.instagram.com/finesseacademyarts" target="_blank" rel="noreferrer">
      <i className="fa-brands fa-instagram" style={{ color: "#d5a092" }}></i>
    </a>
    <a href="#">
      <i className="fa-brands fa-linkedin-in" style={{ color: "#d5a092" }}></i>
    </a>
    <a href="#">
      <i className="fa-brands fa-youtube" style={{ color: "#d5a092" }}></i>
    </a>
  </div>
</div>

                <Navbar collapseOnSelect expand='lg' className="sidebar container">
                    <Navbar.Brand href="/" className="brand-logo">
                        <img src="images/logos.png" alt="Cake & Bake" style={{ width: '170px' }} />
                    </Navbar.Brand>

                    <Navbar.Toggle aria-controls="responsive-navbar-nav" className="justify-content-center" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="nav-menu">
                            <ul className="list_items d-flex justify-content-center">
                                <Nav.Link as={Link} to="/" className={location.pathname === "/" ? "active" : ""}>Home</Nav.Link>
                                <Nav.Link as={Link} to="/aboutus" className={location.pathname === "/aboutus" ? "active" : ""}>About Us</Nav.Link>
                                <Nav.Link as={Link} to="/courses" className={location.pathname === "/courses" ? "active" : ""}>Workshops</Nav.Link>

                                {/* Dropdown for Courses */}
                                <NavDropdown
                                    title={
                                        <>
                                            Courses <i className="fa fa-angle-down down-arrow d-none d-lg-inline"></i>
                                        </>
                                    }
                                    id="courses-dropdown"
                                    className={`nav-link ${location.pathname.includes("/diploma") || location.pathname.includes("/professional-bakery") || location.pathname.includes("/bakeryfoundationcourse") ? "active" : ""}`}
                                    onMouseEnter={() => setShowCoursesDropdown(true)}
                                    onMouseLeave={() => setShowCoursesDropdown(false)}
                                    show={showCoursesDropdown}
                                    style={{ padding: '0' }}>
                                    <div className="mega-menu">
                                        <NavDropdown.Item as={Link} to="/customized-module" className={location.pathname === "/customized-module" ? "active" : ""}>
                                            Customized Module
                                        </NavDropdown.Item>
                                        <NavDropdown.Item as={Link} to="/diploma" className={location.pathname === "/diploma" ? "active" : ""}>
                                            Diploma in Bakery & <br /> Pastry Arts
                                        </NavDropdown.Item>
                                        <NavDropdown.Item as={Link} to="/professional-bakery" className={location.pathname === "/professional-bakery" ? "active" : ""}>
                                            Professional Bakery & <br /> Confectionery Course
                                        </NavDropdown.Item>
                                        <NavDropdown.Item as={Link} to="/bakeryfoundationcourse" className={location.pathname === "/bakeryfoundationcourse" ? "active" : ""}>
                                            Bakery Foundation Course
                                        </NavDropdown.Item>
                                        <NavDropdown.Item as={Link} to="/basic-to-intermediate-course" className={location.pathname === "/basic-to-intermediate-course" ? "active" : ""}>
                                            Basic to Intermediate Course
                                        </NavDropdown.Item>
                                    </div>
                                </NavDropdown>

                                {/* <Nav.Link as={Link} to="/januaryschedule" className={location.pathname === "/januaryschedule" ? "active" : ""}>January Schedule</Nav.Link> */}
                                {/* <Nav.Link as={Link} to="/februaryschedule" className={location.pathname === "/februaryschedule" ? "active" : ""}>February Schedule</Nav.Link> */}
                                {/* <Nav.Link as={Link} to="/marchSchedule" className={location.pathname === "/marchSchedule" ? "active" : ""}>March Schedule</Nav.Link> */}
                                <Nav.Link as={Link} to="/contactus" className={location.pathname === "/contactus" ? "active" : ""}>Contact Us</Nav.Link>
                            </ul>
                        </Nav>
                    </Navbar.Collapse>

                    
                </Navbar>
            </div>
        </div>
    );
}

export default NavbarComponent;
